module.exports = __webpack_public_path__ + "img/Gatormade.03627f5a.png";